import { Suspense, useEffect, useRef, useState } from "react";

export default function DeferredSection({ id, minHeight = 800, children }) {
  const ref = useRef(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === "undefined") {
      setShow(true);
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setShow(true);
          io.disconnect();
        }
      },
      { rootMargin: "800px 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={ref} id={id}>
      {show ? (
        <Suspense fallback={<div aria-hidden style={{ minHeight }} />}>{children}</Suspense>
      ) : (
        <div aria-hidden style={{ minHeight }} />
      )}
    </div>
  );
}
